import { Fragment, h, render } from 'preact';
import { useState } from 'preact/hooks';
import { autoToHTML } from '@sfirew/minecraft-motd-parser';

import Chart from 'chart.js/auto';
import 'chartjs-adapter-date-fns';

type ISammakkoServer = {
    serverId: string;
    serverName?: string | null;
    serverIp?: string | null;
    serverBedrockIp?: string | null;
    serverTags?: string | null;
    serverDiscord?: string | null;
    serverWebsite?: string | null;
    shortMessageContent?: string | null;
    messageContent?: string | null;
    messageId?: string | null;
    apuMessageId?: string | null;
    ownerId?: string | null;
    ownerName?: string | null;
    bannerUrl?: string | null;
    thumbnailUrl?: string | null;
    isActive: boolean; 
    isApproved: boolean; 
    isFeatured: boolean; 
    timeCreated?: number | null;
    timeUpdated?: number | null;
    extraData?: string | null; 
}

function ReportForm(props: {
    serverId: string
}) {
    
    return <form
        onSubmit={e => {
            e.preventDefault();
            const fd = new FormData(e.currentTarget);
            const rawJson = Object.fromEntries(fd as any);
            console.log(rawJson);
        }}>
        
        <div className='row mb-4'>
            <div className='col-12 col-md-5 col-lg-4'>
                <div className='text-start text-lg-end'>
                    <label>Raportoitava ilmoitus</label>
                </div>
            </div>
            <div className='col-12 col-md-8 col-lg-6'>
                <div className=''>
                    <input type='text'
                        value={props.serverId}
                        disabled={true}
                        required={true}
                        spellcheck={false}
                        autoComplete={'off'}
                        name='serverId'
                        className='form-control form-control-sm'
                        />
                </div>
            </div>
        </div>
        
        <div className='row mb-4'>
            <div className='col-12 col-md-5 col-lg-4'>
                <div className='text-start text-lg-end'>
                    <label>Nimesi</label>
                </div>
            </div>
            <div className='col-12 col-md-8 col-lg-6'>
                <div className=''>
                    <input type='text'
                        spellcheck={false}
                        autoComplete={'off'}
                        name='reportSenderName'
                        className='form-control form-control-sm'
                        />
                </div>
            </div>
        </div>
        
        <div className='row mb-4'>
            <div className='col-12 col-md-5 col-lg-4'>
                <div className='text-start text-lg-end'>
                    <label>Sähköpostiosoitteesi</label>
                </div>
            </div>
            <div className='col-12 col-md-8 col-lg-6'>
                <div className=''>
                    <input type='email'
                        spellcheck={false}
                        autoComplete={'off'}
                        name='reportSenderEmail'
                        className='form-control form-control-sm'
                        />
                </div>
            </div>
        </div>
        
        <div className='row mb-4'>
            <div className='col-12 col-md-5 col-lg-4'>
                <div className='text-start text-lg-end'>
                    <label>Selitä, miksi ja miten ilmoitus/serveri rikkoo sääntöjä</label>
                </div>
            </div>
            <div className='col-12 col-md-8 col-lg-6'>
                <div className=''>
                    <textarea
                        className='form-control form-control-sm'
                        rows={5}
                        spellcheck={false}
                        autoComplete={'off'}
                        name='reportContent'
                        required={true}
                        />
                </div>
            </div>
        </div>
        
        <div className='row mb-4'>
            <div className='col-12 col-md-5 col-lg-4'>
                
            </div>
            <div className='col-12 col-md-8 col-lg-6'>
                <button className='btn btn-sm btn-outline-primary' type='submit'>Lähetä ilmoitus</button>
            </div>
        </div>
        
    </form>;
    
}

function ServerEditForm(props: {
    serverId: string,
    serverData: ISammakkoServer,
    editKey: string
}) {
    
    const [isSaved, setSaved] = useState<boolean>(false);
    const [isPosting, setPosting] = useState<boolean>(false);
    const [errors, setErrors] = useState<string[]>([]);
    const [fieldErrors, setFieldErrors] = useState<Record<string, string>>({});
    
    function renderErrors(v: string) {
        if (!fieldErrors[v]) return;
        return <div class='text-danger'>{fieldErrors[v]}</div>;
    }
    
    return <form
        onSubmit={e => {
            
            e.preventDefault();
            const fd = new FormData(e.currentTarget);
            const rawJson = Object.fromEntries(fd as any);
            
            setSaved(false);
            setFieldErrors({});
            setErrors([]);
            setPosting(true);
            
            fetch(`/_api/list.php?h=${encodeURIComponent(props.editKey)}`, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify(rawJson)
            })
                .then(x => {
                    if (!x.ok) {
                        console.error(`${x.status} ${x.statusText}`);
                        setErrors(es => [...es, `Lomakkeen käsittelyssä tapahtui virhe: ${x.status} ${x.statusText}`]);
                        return;
                    }
                    return x.json();
                })
                .then(resp => {
                    if (resp.error) {
                        console.error(resp);
                        setErrors(es => [...es, `${resp.error}`]);
                        return;
                    }
                    console.log(resp);
                    if (resp.fieldErrors) {
                        setFieldErrors(resp.fieldErrors);
                        return;
                    }
                    setSaved(true);
                })
                .catch(err => {
                    console.error(err);
                    setErrors(es => [...es, `${err}`]);
                })
                .finally(() => {
                    setPosting(false);
                })
            
            console.log(rawJson);
            
        }}>
        
        {errors.map(err =>
            <div className='alert alert-danger mb-3'>{err}</div>
        )}
        
        <div className='row mb-4'>
            <div className='col-12 col-md-5 col-lg-4'>
                <div className='text-start text-lg-end'>
                    <label>Tagit</label><br/>
                </div>
            </div>
            <div className='col-12 col-md-8 col-lg-6'>
                <div className=''>
                    {JSON.parse(props.serverData.serverTags ?? '[]').map((t: any) => <span className='badge rounded-pill text-bg-secondary'>{t}</span>)}
                </div>
                <small class="text-secondary"><i>
                    Tagit päivitetään Discord-viestiketjun tageista.
                </i></small>
            </div>
        </div>
        
        <div className='row mb-4'>
            <div className='col-12 col-md-5 col-lg-4'>
                <div className='text-start text-lg-end'>
                    <label>Serverin nimi</label>
                </div>
            </div>
            <div className='col-12 col-md-8 col-lg-6'>
                <div className=''>
                    <input type='text'
                        spellcheck={false}
                        autoComplete={'off'}
                        name='serverName'
                        defaultValue={props.serverData.serverName ?? ''}
                        className='form-control form-control-sm'
                        />
                    {renderErrors('serverName')}
                </div>
            </div>
        </div>
        
        <div className='row mb-4'>
            <div className='col-12 col-md-5 col-lg-4'>
                <div className='text-start text-lg-end'>
                    <label>Liittymisosoite (Java)</label>
                </div>
            </div>
            <div className='col-12 col-md-8 col-lg-6'>
                <div className=''>
                    <input type='text'
                        spellcheck={false}
                        autoComplete={'off'}
                        name='serverIp'
                        placeholder={`osoite:portti`}
                        defaultValue={props.serverData.serverIp ?? ''}
                        className='form-control form-control-sm'
                        />
                    {renderErrors('serverIp')}
                </div>
                <small class="text-secondary"><i>
                    Jätä tyhjäksi, jos serverille pääsee vain Bedrock-versiolla.
                </i></small>
            </div>
        </div>
        
        <div className='row mb-4'>
            <div className='col-12 col-md-5 col-lg-4'>
                <div className='text-start text-lg-end'>
                    <label>Liittymisosoite (Bedrock)</label>
                </div>
            </div>
            <div className='col-12 col-md-8 col-lg-6'>
                <div className=''>
                    <input type='text'
                        spellcheck={false}
                        autoComplete={'off'}
                        name='serverBedrockIp'
                        placeholder={`osoite:portti`}
                        defaultValue={props.serverData.serverBedrockIp ?? ''}
                        className='form-control form-control-sm'
                        />
                    {renderErrors('serverBedrockIp')}
                </div>
                <small class="text-secondary"><i>
                    Jätä tyhjäksi, jos serverille pääsee vain Java-versiolla.
                </i></small>
            </div>
        </div>
        
        <div className='row mb-4'>
            <div className='col-12 col-md-5 col-lg-4'>
                <div className='text-start text-lg-end'>
                    <label>Lyhyt esittely</label>
                </div>
            </div>
            <div className='col-12 col-md-8 col-lg-6'>
                <div className=''>
                    <textarea
                        className='form-control form-control-sm'
                        rows={5}
                        spellcheck={false}
                        autoComplete={'off'}
                        name='shortMessageContent'
                        defaultValue={props.serverData?.shortMessageContent ?? ''}
                        maxLength={500}
                        required={true}
                        />
                    {renderErrors('shortMessageContent')}
                </div>
                <small class="text-secondary"><i>
                    Lyhyt esittelyteksti tai slogan, näytetään usein serverisi nimen yhteydessä.
                    Varsinainen pitkä mainosteksti haetaan Discord-viestiketjusta.
                </i></small>
            </div>
        </div>
        
        <div className='row mb-4'>
            <div className='col-12 col-md-5 col-lg-4'>
                <div className='text-start text-lg-end'>
                    <label>Discord-linkki</label>
                </div>
            </div>
            <div className='col-12 col-md-8 col-lg-6'>
                <div className=''>
                    <input type='text'
                        spellcheck={false}
                        autoComplete={'off'}
                        name='serverDiscord'
                        placeholder={`https://discord.gg/...`}
                        defaultValue={props.serverData.serverDiscord ?? ''}
                        className='form-control form-control-sm'
                        />
                    {renderErrors('serverDiscord')}
                </div>
                <small class="text-secondary"><i>
                    Jätä tyhjäksi, jos Discord-kanavaa ei ole.
                </i></small>
            </div>
        </div>
        
        <div className='row mb-4'>
            <div className='col-12 col-md-5 col-lg-4'>
                <div className='text-start text-lg-end'>
                    <label>Nettisivujen linkki</label>
                </div>
            </div>
            <div className='col-12 col-md-8 col-lg-6'>
                <div className=''>
                    <input type='text'
                        spellcheck={false}
                        autoComplete={'off'}
                        name='serverWebsite'
                        placeholder={`https://...`}
                        defaultValue={props.serverData.serverWebsite ?? ''}
                        className='form-control form-control-sm'
                        />
                    {renderErrors('serverWebsite')}
                </div>
                <small class="text-secondary"><i>
                    Jätä tyhjäksi, jos nettisivuja ei ole. Tähän voi linkittää vaihtoehtoisesti myös sometilin tai VIP-kaupan.
                </i></small>
            </div>
        </div>
        
        <div className='row mb-4'>
            <div className='col-12 col-md-5 col-lg-4'>
                <div className='text-start text-lg-end'>
                    <label>Bannerin taustakuva</label>
                </div>
            </div>
            <div className='col-12 col-md-8 col-lg-6'>
                <div className='x-file-input'>
                    <ImageUpload
                        images={(props.serverData.bannerUrl && props.serverData.bannerUrl != '') ? [props.serverData.bannerUrl] : []}
                        serverId={props.serverId}
                        multi={false}
                        inputName='bannerImage'
                        />
                    {renderErrors('bannerImage')}
                </div>
                <small class="text-secondary"><i>
                    Bannerin näkyvä osa on kuvasuhteeltaan 3:1 ja mobiilissa kapeampi.
                    Suositeltu resoluutio vähintään 1280x720.
                </i></small>
            </div>
        </div>
        
        <div className='row mb-4'>
            <div className='col-12 col-md-5 col-lg-4'>
                <div className='text-start text-lg-end'>
                    <label>Esittelykuvat</label>
                </div>
            </div>
            <div className='col-12 col-md-8 col-lg-6'>
                <div className='x-file-input'>
                    <ImageUpload
                        images={(props.serverData.thumbnailUrl && props.serverData.thumbnailUrl != '') ? JSON.parse(props.serverData.thumbnailUrl) : []}
                        serverId={props.serverId}
                        multi={10}
                        inputName='thumbnailImages'
                        />
                    {renderErrors('thumbnailImages')}
                </div>
            </div>
        </div>
        
        <div className='row mb-4'>
            <div className='col-12 col-md-5 col-lg-4'>
                
            </div>
            <div className='col-12 col-md-8 col-lg-6'>
                <button className='btn btn-success' type='submit'>Tallenna ilmoitus</button>
                {isPosting && <Fragment>
                    <div className='ms-3 spinner-border spinner-border-sm'></div> Hetkinen...
                </Fragment>}
                {(errors.length > 0 || Object.keys(fieldErrors).length > 0) && <Fragment>
                    <span className='text-danger ms-3'>Korjaa virheet!</span>
                </Fragment>}
                {isSaved && <Fragment>
                    <span className='text-success ms-3'>Tallennettu!</span>
                </Fragment>}
            </div>
        </div>
        
    </form>;
    
}

function ImageUpload(props: {
    multi: boolean | number,
    inputName: string,
    serverId: string,
    images: string[]
}) {
    
    const [errors, setErrors] = useState<string[]>([]);
    const [isUploading, setUploading] = useState<string[]>([]);
    const [uploadedImages, setUploadedImages] = useState<string[]>([...props.images]);
    
    return <div className='x-file-upload'>
        
        {errors.map(er =>
            <div className='alert alert-danger'>{er}</div>
        )}
        
        <div className='x-preview mb-2'>
            {uploadedImages.length == 0 && <i className='text-secondary'>Valitse enintään {props.multi || 1} kuva{(props.multi || 1) == 1 ? '' : 'a'}.</i>}
            {uploadedImages.map((im, i) =>
                <img
                    key={im}
                    src={`/_uploads/${im}`}
                    onClick={e => {
                        e.preventDefault();
                        if (confirm(`Poista kuva?`)) {
                            setUploadedImages(ims => ims.filter(m => m != im));
                        }
                    }}
                    />
            )}
        </div>
        
        <input
            type='file'
            accept='image/*'
            className='form-control form-control-sm'
            name='files'
            multiple={!!props.multi}
            onInput={e => {
                const inp = e.currentTarget;
                if (!inp) {
                    return;
                }
                console.log(e.currentTarget.files);
                if (uploadedImages.length + (e.currentTarget.files?.length ?? 0) > (typeof props.multi == 'number' ? props.multi : 1)) {
                    alert(`Voit valita enintään ${props.multi || 1} kuvaa. Poista kuvia klikkaamalla niitä.`);
                    return;
                }
                (async () => {
                    if (!e.currentTarget.files || e.currentTarget.files.length == 0) {
                        return;
                    }
                    const files: File[] = [];
                    for (let i = 0; i < e.currentTarget.files.length; i++) {
                        const f = e.currentTarget.files.item(i);
                        if (!f) continue;
                        files.push(f);
                    }
                    for (const f of files) {
                        
                        setUploading(u => [...u, f.name]);
                        
                        const fd = new FormData();
                        fd.set('file', f);
                        fd.set('serverId', props.serverId);
                        
                        const x = await fetch(`/upload.php`, {
                            body: fd,
                            method: 'POST'
                        });
                        if (!x.ok) {
                            console.error(`upload err: ${x.status} ${x.statusText}`);
                            setErrors(er => [...er, `Tapahtui virhe: ${x.status} ${x.statusText}`]);
                            continue;
                        }
                        const resp = await x.json();
                        if (resp.error) {
                            console.error(`upload err: ${x.status} ${x.statusText} ${resp.error}`);
                            setErrors(er => [...er, `Virhe: ${resp.error}`]);
                            continue;
                        }
                        
                        const imageId = resp.imageId;
                        setUploadedImages(is => [...is, imageId]);
                        
                    }
                    inp.value = '';
                })()
                    .catch(err => {
                        console.error(err);
                    })
            }}
            />
        
        <input
            type='hidden'
            name={props.inputName}
            value={JSON.stringify(uploadedImages)}
            />
        
    </div>;
    
}

document.addEventListener('DOMContentLoaded', () => {
    
    const reportForm = document.querySelector('#reportForm');
    const serverId = reportForm?.getAttribute('data-server-id');
    if (reportForm && serverId) {
        render(
            <ReportForm serverId={serverId}/>,
            reportForm
        );
    }
    
    
    const editForm = document.querySelector('#editServer');
    const serverEditId = editForm?.getAttribute('data-server-id');
    const serverEditKey = editForm?.getAttribute('data-edit-key');
    const serverEditData = editForm?.getAttribute('data-server');
    if (editForm && serverEditData) {
        render(
            <ServerEditForm
                editKey={serverEditKey || ''}
                serverId={serverEditId || ''}
                serverData={JSON.parse(serverEditData || '{}')}
                />,
            editForm
        );
    }
    
    
    const pingRenders = document.querySelectorAll('[data-render-motd]');
    for (const el of [...(pingRenders as any)]) {
        const rawMotd = el.getAttribute('data-render-motd');
        try {
            const motdJson = JSON.parse(rawMotd);
            el.innerHTML = autoToHTML(motdJson);
        } catch (err) {
            el.innerHTML = autoToHTML(rawMotd);
        }
    }
    
    
    const statRender = document.querySelector('#serverPingStats');
    const statRenderId = statRender?.getAttribute('data-server-id');
    if (statRender && statRenderId) {
        fetch(`/_api/stats.php?serverId=${encodeURIComponent(statRenderId)}`)
            .then(x => x.json())
            .then(resp => {
                
                console.log(resp);
                
                const playerChartCtx = document.createElement('canvas');
                playerChartCtx.width = 800;
                playerChartCtx.height = 450;
                
                statRender.appendChild(playerChartCtx);
                
                const ch = new Chart<'line'>(playerChartCtx, {
                    type: 'line',
                    data: {
                        datasets: [{
                            label: 'Pelaajat',
                            fill: false,
                            pointRadius: 0,
                            data: resp.data.map((row: any) => ({
                                x: new Date(row.timestamp),
                                y: row.pingPlayers
                            }))
                        }]
                    },
                    options: {
                        scales: {
                            x: {
                                type: 'time',
                                time: {
                                    displayFormats: {
                                        hour: 'HH:mm',
                                        day: 'MMM d'
                                    }
                                },
                                ticks: {
                                    major: {
                                        enabled: true
                                    },
                                }
                            }
                        },
                        responsive: true,
                        aspectRatio: 10 / 4
                    }
                });
                
                const pingChartCtx = document.createElement('canvas');
                pingChartCtx.width = 800;
                pingChartCtx.height = 450;
                
                statRender.appendChild(pingChartCtx);
                
                const ch2 = new Chart<'line'>(pingChartCtx, {
                    type: 'line',
                    data: {
                        datasets: [{
                            label: 'Vasteaika (ms)',
                            borderColor: 'pink',
                            fill: false,
                            pointRadius: 0,
                            data: resp.data.map((row: any) => ({
                                x: new Date(row.timestamp),
                                y: row.pingMs
                            }))
                        }]
                    },
                    options: {
                        scales: {
                            x: {
                                type: 'time',
                                time: {
                                    displayFormats: {
                                        hour: 'HH:mm',
                                        day: 'MMM d'
                                    }
                                },
                                ticks: {
                                    major: {
                                        enabled: true
                                    },
                                }
                            }
                        },
                        responsive: true,
                        aspectRatio: 10 / 4
                    }
                });
                
                const rankChartCtx = document.createElement('canvas');
                rankChartCtx.width = 800;
                rankChartCtx.height = 450;
                
                statRender.appendChild(rankChartCtx);
                
                const ch3 = new Chart<'line'>(rankChartCtx, {
                    type: 'line',
                    data: {
                        datasets: [{
                            label: 'Pisteytys',
                            borderColor: 'gold',
                            fill: false,
                            pointRadius: 0,
                            data: resp.data2.map((row: any) => ({
                                x: new Date(row.timestamp),
                                y: row.serverPoints
                            }))
                        }]
                    },
                    options: {
                        scales: {
                            x: {
                                type: 'time',
                                time: {
                                    displayFormats: {
                                        hour: 'HH:mm',
                                        day: 'MMM d'
                                    }
                                },
                                ticks: {
                                    major: {
                                        enabled: true
                                    },
                                }
                            }
                        },
                        responsive: true,
                        aspectRatio: 10 / 4
                    }
                });
                
            })
            .catch(err => {
                console.error(err);
                statRender.innerHTML = `<div class="alert alert-warning">Tietojen haku epäonnistui.</div>`;
            })
    }
    
    
    document.body.addEventListener('click', e => {
        if (e.target && e.target instanceof HTMLImageElement && e.target.matches('.x-image-gallery img')) {
            window.open(e.target.getAttribute('src') || '#');
        }
    });
    
})